import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'

class OfferBookingApprovalService {
  constructor() {
    this.resource = API_RESOURCE.OFFER
  }

  inviteBookingUser = async ({ offerId, approverIndex, ...data }) => {
    const response = await axios.post(`${this.resource}/${offerId}/booking/approval/${approverIndex}/invitation`, data)
    return response.data
  }

  replyBookingInvitation = async ({ offerId, approverIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/booking/approval/${approverIndex}/invitation/reply`,
      data
    )
    return response.data
  }

  deleteBookingInvitedUsers = async ({ offerId, approverIndex, ...data }) => {
    const response = await axios.delete(
      `${this.resource}/${offerId}/booking/approval/${approverIndex}/invitation/batch`,
      {
        data,
      }
    )
    return response.data
  }
}

export default OfferBookingApprovalService
